export default {
	weeks: {
		0: '周日',
		1: '周一',
		2: '周二',
		3: '周三',
		4: '周四',
		5: '周五',
		6: '周六'
	},
	// 与本人关系
	relation: {
		1: '本人',
		2: '父母',
		3: '子女',
		4: '配偶',
		5: '家属', // '亲属'
		6: '朋友',
		7: '其他'
	},
	// 性别
	gender: {
		0: '女',
		1: '男'
	},
	// 预约状态
	subscribe: {
		1: '待开始',
		2: '进行中',
		3: '已结束',
		4: '已取消'
	},
	highPressureStatus: {
		1: '正常',
		2: '偏高'
	},
	strokeType: {
		1: '缺血性卒中合并高血压',
		2: '脑出血合并高血压',
		3: '卒中伴糖尿病伴高血压',
		4: '无'
	},
	// 指标状态
	bloodStatus: {
		1: 'normal',
		2: 'high',
		3: 'low'
	},
	bloodStatusStr: {
		normal: '正常',
		high: '偏高',
		low: '偏低'
	},
	// 血糖类型
	bloodSugarType: {
		1: '空腹',
		2: '餐后',
		3: '随机'
	},
	// 支付状态
	payStatus: {
		1: '待支付',
		2: '已支付',
		3: '已取消'
	},
	// 1.待支付 2.待开始 3.进行中 4.已完成 5.已取消-超时未支付 6.已取消-超时未进入
	consultOrderStatus: {
		1: '待支付',
		2: '待开始',
		3: '进行中',
		4: '已完成',
		5: '已取消',
		6: '已取消'
	}
}
